import firebase from 'firebase/app';
import 'firebase/remote-config';

const DEFAULT_CONFIG = {
  urclyrd: '{}',
  podesubir: '{}',
};

let initialized = false;

export const fetchRemoteConfig = async () => {
  if (initialized) return;

  const remoteConfig = firebase.remoteConfig();

  remoteConfig.settings = {
    minimumFetchIntervalMillis: process.env.NODE_ENV === 'development' ? 0 : 3600000,
    fetchTimeoutMillis: 10000,
  };

  remoteConfig.defaultConfig = DEFAULT_CONFIG;

  await remoteConfig.fetchAndActivate();

  initialized = true;
};

export const getRemoteValue = (key) => {
  return firebase.remoteConfig().getValue(key);
};
